import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import SoftLaunchBanner from './SoftLaunchBanner';
import BuyMeACoffee from './BuyMeACoffee';

const Layout = () => {
  return (
    <div className="flex min-h-screen max-w-[100vw] flex-col overflow-x-clip">
      <Header />
      <div className="pt-[4.25rem] sm:pt-20">
        <SoftLaunchBanner />
      </div>
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <BuyMeACoffee />
    </div>
  );
};

export default Layout;
